import React from 'react';
import { bonuses } from '../data/bonuses';
import { Eyebrow } from './Eyebrow';
export function Bonuses() {
  return <section aria-labelledby="bonuses-heading" className="bg-night-900 py-16 sm:py-24" data-id="element-30" data-mp="piy04dxcphgc">
      <div className="mx-auto max-w-shell px-5 sm:px-6" data-id="element-31" data-mp="avv1u517f4ry">
        <div className="max-w-2xl" data-id="element-32" data-mp="at8tw4aein97">
          <Eyebrow data-id="element-33" data-mp="fteej0i979hs">W zestawie dziś bez dodatkowych kosztów</Eyebrow>
          <h2 id="bonuses-heading" className="mt-5 font-display text-4xl leading-[0.98] text-cream sm:text-6xl" data-id="element-34" data-mp="1uer1w6h90n7">
            Sześć darmowych <span className="text-amber" data-id="element-35" data-mp="5xjpnnnfsi6k">bonusów</span>
          </h2>
          <p className="mt-5 font-serif text-lg italic text-cream-soft" data-id="element-36" data-mp="3o2ekzpcku500">
            Realna wartość <span className="text-cream-muted line-through" data-id="element-37" data-mp="3t06hyxs2whb2">$300</span> &mdash;{' '}
            <span className="text-amber" data-id="element-38" data-mp="1mai3lz3qa0xb">dziś całkowicie za darmo z Arsenałem.</span>
          </p>
        </div>
        <ul className="mt-8 grid gap-5 sm:mt-12 sm:grid-cols-2 lg:grid-cols-3 lg:gap-6" data-id="element-39" data-mp="1r9uzf9ckuic1">
          {bonuses.map(bonus => <li key={bonus.number} className="flex flex-col overflow-hidden rounded-2xl border border-night-600 bg-night-800" data-id="element-40" data-mp="3id54555371a9">
              <img src={bonus.image} alt={`Okładka: ${bonus.title}`} className="aspect-square w-full object-cover" loading="lazy" data-id="element-41" data-mp="3r79or6tmnghc" />
              <div className="flex flex-1 flex-col p-6 sm:p-7" data-id="element-42" data-mp="2zeskuqkgob0y">
                <div className="flex items-center justify-between gap-4" data-id="element-43" data-mp="2ugh9gbeipsgm">
                  <span className="text-[11px] font-semibold uppercase tracking-label text-cream-muted" data-id="element-44" data-mp="2uibya0swu4pz">
                    Bonus {bonus.number}
                  </span>
                  <span className="whitespace-nowrap rounded-full bg-ember px-2.5 py-1 text-[10px] font-bold uppercase tracking-[0.12em] text-cream" data-id="element-45" data-mp="33ge36rfrlhij">
                    {bonus.value} &middot; Gratis
                  </span>
                </div>
                <h3 className="mt-5 font-display text-2xl leading-tight text-cream" data-id="element-46" data-mp="itatk7ehbz4w">{bonus.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-cream-soft" data-id="element-47" data-mp="3hhzlpg7dc7cv">{bonus.description}</p>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}